import echarts from 'echarts'

const RISE = 'rgba(230,53,53,0.5)'
const FALL = 'rgba(0,122,255,0.5)'

const BS = {
  initSingle (type) {
    return {
      sIndex: -1,
      eIndex: -1,
      midIndex: -1,
      sPrice: 0,
      ePrice: 0,
      midPrice: type === '0' ? Infinity: -Infinity,
      type: -1
    }
  },
  // buy: c => c
  // sell: c => o
  getPeerPrice(kline, index, type) {
    return kline.c[index]
  },
  getMidPrice (kline, index, type) {
    return type === '0' ? kline.l[index] : kline.h[index]
  },
  setMidPirce (signle, index, kline, type) {
    let price = BS.getMidPrice(kline, index, type)
    let isBuy = signle.type === '1'
    if((price > signle.midPrice) === isBuy) {
      signle.midPrice = price
      signle.midIndex = index
    }
  },
  encodeData (kline, bs) {
    let res = []
    let signle = BS.initSingle(bs[0].bs)
    bs.forEach((item, index) => {
      let type = item.bs
      index > 0 && BS.setMidPirce(signle, index, kline, type)
      if(signle.type !== type) {
        let price = BS.getPeerPrice(kline, index, type)
        if(index > 0) {
          signle.eIndex = index
          signle.ePrice = price
          res.push(signle)
        }
        signle = BS.initSingle(type)
        signle.sIndex = index
        signle.sPrice = price
        signle.type = type
        BS.setMidPirce(signle, index, kline, type)
      }
    })
    kline.bs = res
    return kline
  },
  decodeData (data) {
    let res = []
    let type = ''
    data.forEach(item => {
      res.push([item.sIndex, item.sPrice])
      res.push([item.midIndex, item.midPrice])
      res.push([item.eIndex, item.ePrice])
      type = item.type
    })
    return {
      res,
      type
    }
  },
  series(data) {
    return {
      type: 'custom',
      renderItem: function renderItem (params, api) {
        if(params.context.rendered) {
          return;
        }
        params.context.rendered = true;

        let children = []

        data.forEach(item => {
          let bsData = BS.decodeData([item])
          let color = bsData.type === '1' ? RISE : FALL
          let points = []
          for(let i = 0; i < 3; i++) {
            points.push(api.coord(bsData.res[i]))
          }
          points = echarts.graphic.clipPointsByRect(points, {
            x: params.coordSys.x,
            y: params.coordSys.y,
            width: params.coordSys.width,
            height: params.coordSys.height
          })
          children.push({
            type: 'polygon',
            shape: {
              points: points
            },
            style: api.style({
              fill: color,
              stroke: color
            })
          })
        })
        return {
          type: 'group',
          children
        }
      },
      data: BS.decodeData(data).res
    }
  }
}

export default BS
